export default "__VITE_ASSET__w4x0_uQ9__"